module.exports = __webpack_public_path__ + "assets/img/icon-newmember.e55aa8ea.svg";